import {
  GridToolbarColumnsButton,
  GridToolbarProps,
  GridToolbarResetButton,
} from '@issuemanager/apps/client/components';
import { Stack } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import { SLAViewDto } from '@issuemanager/api-client';
import {
  SLAsGridToolbarAddSLA,
  SLAsGridToolbarAddSLAProps,
} from './slas-grid-toolbar-add-sla';
import {
  SLAsGridToolbarEditSLA,
  SLAsGridToolbarEditSLAProps,
} from './slas-grid-toolbar-edit-sla';
import {
  SLAsGridToolbarDeleteSLA,
  SLAsGridToolbarDeleteSLAProps,
} from './slas-grid-toolbar-delete-sla';

type SLAsGridToolbarProps = GridToolbarProps &
  SLAsGridToolbarAddSLAProps &
  SLAsGridToolbarDeleteSLAProps &
  SLAsGridToolbarEditSLAProps & {
    selectedSLAs: SLAViewDto[];
  };

export function SLAsGridToolbar(props: SLAsGridToolbarProps) {
  const {
    columns,
    selectedSLAs,
    onAddSLAClick,
    onEditSLAClick,
    onDeleteSLAClick,
  } = props;

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton columns={columns} />
      <GridToolbarResetButton />
      <Stack direction='row' flex={1} justifyContent='flex-end' spacing={1}>
        {selectedSLAs.length === 1 ? (
          <SLAsGridToolbarEditSLA onEditSLAClick={onEditSLAClick} />
        ) : null}
        {selectedSLAs.length ? (
          <SLAsGridToolbarDeleteSLA onDeleteSLAClick={onDeleteSLAClick} />
        ) : null}
        <SLAsGridToolbarAddSLA onAddSLAClick={onAddSLAClick} />
      </Stack>
    </GridToolbarContainer>
  );
}
